/* eslint-disable jsx-a11y/no-static-element-interactions */
import { ChevronDown, ChevronUp } from 'lucide-react';
import React, { useState } from 'react';

const InfoToggle = ({
  children,
  title = '',
  openIcon = <ChevronDown size={20} className='tw-mt-[1px]' />,
  closeIcon = <ChevronUp size={20} className='tw-mt-[1px]' />,
  defaultOpen = false,
  onOpen = () => {},
  onClose = () => {},
  duration = 300,
  styles = '',
}) => {
  const [showContent, setShowContent] = useState(defaultOpen);

  const toggleContent = () => {
    setShowContent((prev) => {
      if (prev) onClose();
      else onOpen();
      return !prev;
    });
  };

  return (
    <div
      className={`tw-flex tw-flex-col tw-font-medium tw-text-[1.3rem] tw-rounded-lg ${styles}`}
    >
      <div
        className='tw-flex tw-items-center tw-gap-1 tw-cursor-pointer tw-leading-none tw-text-[1.3rem] tw-w-full'
        onClick={toggleContent}
      >
        {title} {showContent ? closeIcon : openIcon}
      </div>

      <div
        className={`tw-bg-white tw-rounded-lg tw-p-0 tw-m-0 tw-border tw-border-solid tw-border-grey-200 tw-grid tw-transition-all tw-ease-in-out ${
          showContent
            ? 'tw-opacity-100 tw-visible tw-pointer-events-auto tw-mt-2'
            : 'tw-opacity-0 tw-invisible tw-pointer-events-none'
        }`}
        style={{
          gridTemplateRows: showContent ? '1fr' : '0fr',
          transitionDuration: `${duration}ms`,
        }}
      >
        <div className='tw-min-h-0 tw-overflow-hidden'>{children}</div>
      </div>
    </div>
  );
};

export default InfoToggle;
